import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import { Dispatch, StateUpdater } from 'preact/hooks';
import { ComponentChildren } from 'preact';
import { SalesPageState } from './page-editor';
import { SalesBlockDefinition } from './types';

export type PageBuilderContextValue = {
  pageState: SalesPageState;
  setPageState: Dispatch<StateUpdater<SalesPageState>>;
  blockDefinitions: Record<string, SalesBlockDefinition>;
};

const PageBuilderContext = createContext<PageBuilderContextValue | undefined>(undefined);

type PageBuilderProviderProps = {
  pageState: SalesPageState;
  setPageState: Dispatch<StateUpdater<SalesPageState>>;
  blockDefinitions: Record<string, SalesBlockDefinition>;
  children: ComponentChildren;
};

export function PageBuilderProvider({
  pageState,
  setPageState,
  blockDefinitions,
  children,
}: PageBuilderProviderProps) {
  const contextValue: PageBuilderContextValue = {
    pageState,
    setPageState,
    blockDefinitions,
  };

  return <PageBuilderContext.Provider value={contextValue}>{children}</PageBuilderContext.Provider>;
}

export function usePageBuilderContext(): PageBuilderContextValue {
  const context = useContext(PageBuilderContext);
  if (!context) {
    throw new Error('usePageBuilderContext must be used within a PageBuilderProvider');
  }
  return context;
}
